import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowDown, ArrowUpRight, Check, Instagram, Menu, X } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/wyeeJtwvu1HiXsJKfGXny6/1.png';
const ICE_IMAGE = 'https://cdn.magicpatterns.com/uploads/knKE32EsZkYsqPa1ui7YrB/DSC03885.jpg';
const SOCIAL_IMAGE = 'https://cdn.magicpatterns.com/uploads/m4VHGC1GgxgtGcoFZGpH81/IMG_0693.jpg';
const CAN_IMAGE = 'https://cdn.magicpatterns.com/uploads/wDu3fKhK1RBeGFe1tY72ry/DSC03888.jpg';
const VIDEO_MOMENT = 'https://cdn.magicpatterns.com/uploads/macVvEoEwdpGBSYDC8PDiv/CPSTHLM_30.mp4';
const PEOPLE_IMAGE_1 = 'https://cdn.magicpatterns.com/uploads/1KzvTsy3KfZ88WPDkaVLMn/WAGHORN_2026-03-22_18.jpg';
const PEOPLE_IMAGE_2 = 'https://cdn.magicpatterns.com/uploads/oLZUyGYJTdHH83PscaSwsS/IMG_0700.jpg';
const ICE_BOWL_IMAGE = 'https://cdn.magicpatterns.com/uploads/p4Sk3dNMD8P9BQwDabDdK8/DSC04025.jpg';
const CLOSING_IMAGE = 'https://cdn.magicpatterns.com/uploads/mUGwrPwqeYegR1sEkvQE7m/IMG_0669_4.png';
const CROWD_IMAGE = 'https://cdn.magicpatterns.com/uploads/q1QGnD1Kd2T9Us82VxWgCC/2025-11-09_-67.jpg';
const SILVER_HEART = 'https://cdn.magicpatterns.com/uploads/rJT9byhsXeU9KaTKr1LjUf/1.png';
const BEET_RED = 'https://cdn.magicpatterns.com/uploads/qULQc3HvRqojPLg7YXAYH5/Rodbeta.png';
const BEET_YELLOW = 'https://cdn.magicpatterns.com/uploads/3uGPvVV79oZz5PUQ2CQhbW/gulbeta.png';
const BEET_WHITE = 'https://cdn.magicpatterns.com/uploads/4xdunyqX2XsEhDvajcVBUY/VITBETA.png';
const CAN_LINEUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/4nRxNXZRgXs6U5T42kX5ab/Burk_1.png';
const INSTAGRAM_URL = 'https://www.instagram.com/beatyourbest_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const CONTACT_EMAIL = 'info@beatsoda.com';
const WEB3FORMS_KEY = 'a23b9419-6869-4092-bd1e-0a48a2461c5e';
const EASE = [0.23, 1, 0.32, 1] as const;
const rise = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: EASE
    }
  }
};
const stagger = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05
    }
  }
};
const WORLD_WORDS = ['Music', 'Food', 'Friends', 'Travel', 'Sport', 'Nightlife'];
const NAV_LINKS = [{
  label: 'The Drink',
  id: 'product'
}, {
  label: 'Flavours',
  id: 'flavours'
}, {
  label: 'World',
  id: 'world'
}, {
  label: 'People',
  id: 'people'
}, {
  label: 'Story',
  id: 'story'
}, {
  label: 'Join',
  id: 'join'
}];
const COMING_SOON = [{
  name: 'Yellow BEAT',
  symbol: BEET_YELLOW
}, {
  name: 'White BEAT',
  symbol: BEET_WHITE
}];
const INGREDIENTS = ['Beetroot', 'Grapefruit', 'Pomegranate', 'Lemon', 'Elderflower', 'Apple Juice Concentrate', 'Apple Cider Vinegar'];
export function LandingPage() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-beat-black font-sans text-white antialiased" data-id="element-1" data-mp="2bxmopnyha3zi">
      <SiteHeader onNavigate={scrollTo} data-id="element-2" data-mp="2bva6d9ot5rlx" />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="relative min-h-screen w-full overflow-hidden" data-id="element-3" data-mp="2ln694y1ua5wh">
        <motion.img src={ICE_IMAGE} alt="A cold BEAT can buried in crushed ice" initial={{
        opacity: 0,
        scale: 1.06
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: EASE
      }} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-4" data-mp="2lp0sw91djryz" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to top, rgba(10,10,10,0.88) 0%, rgba(10,10,10,0.45) 45%, rgba(10,10,10,0.12) 75%, rgba(255,255,255,0.35) 100%)'
      }} data-id="element-5" data-mp="21yfcx57e6hei" />

        <motion.div initial="hidden" animate="visible" variants={stagger} className="relative z-10 flex min-h-screen flex-col justify-end px-5 pb-20 pt-40 md:px-10 md:pb-24" data-id="element-6" data-mp="3devhu4lblfn4">
          <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-white/70 uppercase" data-id="element-7" data-mp="3gvrntg2jxsik">
            REAL ROOT · REAL FRUIT · REAL FLAVOUR
          </motion.p>

          <motion.h1 variants={rise} className="max-w-[18ch] text-5xl font-medium leading-[1.1] tracking-tight md:text-7xl lg:text-8xl" style={{
          fontSize: "96px"
        }} data-id="element-8" data-mp="3bz9juif1py7a">
            A real way to experience  <span className="text-beat-red" data-id="element-9" data-mp="3p83hsfg0m8x">life.</span>
          </motion.h1>

          <motion.div variants={rise} className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center" data-id="element-10" data-mp="3n52yegnzapy">
            <button onClick={() => scrollTo('product')} className="group inline-flex items-center gap-3 rounded-full bg-beat-red px-8 py-4 text-base font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black" style={{
            transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)',
            width: "209px",
            height: "53px"
          }} data-id="element-11" data-mp="3utycc5lm2g5k">
              Discover BEAT
              <ArrowUpRight size={18} className="transition-transform duration-150 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-12" data-mp="hih69a8vy9ih" />
            </button>
            <p className="max-w-xs text-base text-white/60" data-id="element-13" data-mp="16213hsrl6j23">
              A Real Root & Fruit Soda 
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.6,
        duration: 0.6
      }} className="absolute bottom-8 right-5 z-10 text-white/50 md:right-10" data-id="element-14" data-mp="s4ch2ghvf3ux">
          <ArrowDown size={22} className="animate-bounce" data-id="element-15" data-mp="n3eyi2sy87sw" />
        </motion.div>
      </section>

      {/* ── 02: THIS IS BEAT (PRODUCT) ───────────────────────── */}
      <section id="product" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-16" data-mp="8c65rktr26bj">
        <div className="mx-auto grid max-w-[1200px] items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-17" data-mp="db0xjc9p357s">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} data-id="element-18" data-mp="3vktd2h8szkck">
            <motion.p variants={rise} className="mb-8 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-19" data-mp="261url6tmpr1c">
              The Drink
            </motion.p>
            <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-20" data-mp="1wbrr6lk6hasz">
              This is BEAT.
            </motion.h2>
            <motion.p variants={rise} className="mt-8 max-w-md text-xl leading-relaxed text-white/70" data-id="element-21" data-mp="1sbhl78wdyke4">
              A drink for the moments worth remembering. Bright, bold, rewarding, and balanced.
            </motion.p>

            <motion.button variants={rise} onClick={() => scrollTo('flavours')} className="mt-10 inline-flex items-center gap-2 text-base font-medium text-beat-red transition-colors hover:text-white" data-id="element-22" data-mp="2k25j8c2rj9nk">
              Discover the flavours <ArrowDown size={18} data-id="element-23" data-mp="14kly2p2vkdd7" />
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.8,
          ease: EASE
        }} className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl" data-id="element-24" data-mp="14i975mf52so0">
            <img src={CAN_IMAGE} alt="A BEAT can resting on a railing" className="h-full w-full object-cover" data-id="element-25" data-mp="3k8hosqsh36zp" />
          </motion.div>
        </div>
      </section>

      {/* ── 02B: THE FLAVOURS ────────────────────────────────── */}
      <section id="flavours" className="scroll-mt-20 rounded-t-[3rem] bg-[#F5F3EF] px-5 py-20 text-beat-black md:px-10 md:py-28" data-id="element-26" data-mp="3u1ghajr3bhol">
        <div className="mx-auto max-w-[1200px]" data-id="element-27" data-mp="7sf8eb0ut6os">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-10 md:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] md:items-end" data-id="element-28" data-mp="7snk3zl8q5ye">
            <div data-id="element-29" data-mp="2dl459c964bw7">
              <motion.p variants={rise} className="mb-6 text-sm font-medium uppercase tracking-widest text-beat-red" data-id="element-30" data-mp="2dkkm5s7s7hgl">
                The Flavours
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium leading-[1.05] tracking-tight md:text-6xl" data-id="element-31" data-mp="1umisbhpyon4f">
                Meet BEAT.
              </motion.h2>
              <motion.div variants={rise} className="mt-8 h-px w-16 bg-beat-red" data-id="element-32" data-mp="23gnlw8whccnn" />
            </div>
            <motion.p variants={rise} className="max-w-md text-xl leading-relaxed text-black/60" data-id="element-33" data-mp="1zg3px8nn7f33">
              Bold. Refreshing. Made from real ingredients. For real moments. We
              start with one — the red beet.
            </motion.p>
          </motion.div>

          {/* Red BEAT — available now */}
          <motion.article initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="mt-16" data-id="element-34" data-mp="1kol2wqwd8ka8">
            <motion.div variants={rise} className="py-4 md:py-8" data-id="element-35" data-mp="2w4jmhop66opp">
              <img src={CAN_LINEUP_IMAGE} alt="Red BEAT can shown from three sides, with beetroot artwork, ingredients and nutrition" className="mx-auto w-full max-w-4xl mix-blend-darken" data-id="element-36" data-mp="2r79m5e08ssn3" />
            </motion.div>
            <motion.div variants={rise} className="grid gap-10 border-t border-black/10 pt-10 md:grid-cols-2 md:pt-14" data-id="element-37" data-mp="33qeyr49mgeqn">
              <div data-id="element-38" data-mp="2pr5kwb8w1wpu">
                <div className="flex items-center gap-3" data-id="element-39" data-mp="2prp4rxi3mv6i">
                  <span className="h-3 w-3 rounded-full bg-beat-red" data-id="element-40" data-mp="2upqjy7cemacp" />
                  <span className="text-sm font-medium uppercase tracking-widest text-beat-red" data-id="element-41" data-mp="3iei3kabxhkdv">
                    Available now
                  </span>
                </div>
                <div className="mt-5 flex items-center gap-5" data-id="element-42" data-mp="3nf5uyx42k38m">
                  <img src={BEET_RED} alt="" aria-hidden="true" className="h-24 w-auto flex-shrink-0 mix-blend-darken md:h-32" data-id="element-43" data-mp="38nxbl5qrfe3x" />
                  <h3 className="text-3xl font-medium tracking-tight md:text-5xl" data-id="element-44" data-mp="3dl6x4ab135mh">
                    Red BEAT
                  </h3>
                </div>
                <p className="mt-5 max-w-md text-lg leading-relaxed text-black/60" data-id="element-45" data-mp="9zhxb6frlgjp">
                  Beetroot meets grapefruit, pomegranate and citrus in a vibrant
                  blend with floral notes and a crisp finish.
                </p>
              </div>
              <div className="flex flex-col justify-center gap-6 md:border-l md:border-black/10 md:pl-14" data-id="element-46" data-mp="2433k2xaj75su">
                <div className="flex flex-wrap gap-x-6 gap-y-3 text-base text-black/70" data-id="element-47" data-mp="291eub94qnibl">
                  {INGREDIENTS.map(item => <span key={item} data-id="element-48" data-mp="1ubz7g48bvx16">{item}</span>)}
                </div>
                <p className="border-t border-black/10 pt-6 text-base text-black/50" data-id="element-49" data-mp="1z3gx3w4wib6u">
                  250 ml · No added sugar · Low calorie · Caffeine free ·
                  Alcohol free
                </p>
              </div>
            </motion.div>
          </motion.article>

          {/* Yellow + White — coming soon */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="mt-6 grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-50" data-mp="1bf7fz7imubm1">
            {COMING_SOON.map(flavour => <motion.article key={flavour.name} variants={rise} className="flex items-center gap-6 rounded-3xl border border-black/10 p-8" data-id="element-51" data-mp="wrpiou7egj9n">
                <img src={flavour.symbol} alt="" aria-hidden="true" className="h-24 w-auto flex-shrink-0 opacity-60 mix-blend-darken" data-id="element-52" data-mp="16pdc9gt9rkq8" />
                <div data-id="element-53" data-mp="11pr3bjkh4qn8">
                  <h3 className="text-xl font-medium tracking-tight text-black/70 md:text-2xl" data-id="element-54" data-mp="11p8zo1vhfa5a">
                    {flavour.name}
                  </h3>
                  <p className="mt-1 text-base text-black/45" data-id="element-55" data-mp="1as0abzgja1vv">Coming soon</p>
                </div>
              </motion.article>)}
          </motion.div>

          <motion.p initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={rise} className="mt-12 text-base text-black/50" data-id="element-56" data-mp="1pi7i9l8x02ib">
            No alcohol. No caffeine. Nothing artificial.
          </motion.p>
        </div>
      </section>

      {/* ── MARQUEE ──────────────────────────────────────────── */}
      <Marquee data-id="element-57" data-mp="21ixqm764wjyg" />

      {/* ── 03: THE WORLD ────────────────────────────────────── */}
      <section id="world" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-58" data-mp="26h91ml8610i9">
        <div className="mx-auto max-w-[1200px]" data-id="element-59" data-mp="26f65rkkc0d5m">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] lg:gap-16" data-id="element-60" data-mp="2bfk9writb2yd">
            <div data-id="element-61" data-mp="2kb02743x5a1u">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-62" data-mp="2p808ng4oketh">
                The World
              </motion.p>
              <motion.p variants={rise} className="text-3xl font-medium leading-snug text-white md:text-4xl" data-id="element-63" data-mp="2u7uxzf8t4wcf">
                BEAT lives where good people, good taste and good experiences
                meet.
              </motion.p>
              <motion.p variants={rise} className="mt-6 max-w-sm text-lg leading-relaxed text-white/60" data-id="element-64" data-mp="14s57t1rtgdsz">
                A dinner. A festival. A studio. A beach. A basement bar at 1am.
                The place changes. The feeling doesn't.
              </motion.p>
            </div>

            <motion.div variants={rise} data-id="element-65" data-mp="3d9vgnlzsshsy">
              <ul className="flex flex-wrap items-baseline gap-x-6 gap-y-2" data-id="element-66" data-mp="399bm8q6lzsai">
                {WORLD_WORDS.map(word => <li key={word} className="text-4xl font-medium tracking-tight text-white/85 md:text-5xl lg:text-6xl" data-id="element-67" data-mp="34c2zsdefh23g">
                    {word}
                    <span className="text-beat-red" data-id="element-68" data-mp="4tsgs2exfxf6">.</span>
                  </li>)}
              </ul>
              <p className="mt-10 text-2xl font-medium text-beat-red md:text-3xl" data-id="element-69" data-mp="sgr5ww1zc6z">
                Something is happening.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── MOMENT: THE FLOOR ────────────────────────────────── */}
      <Moment src={CROWD_IMAGE} alt="A packed room dancing in front of a DJ booth" label="Stockholm · Saturday" data-id="element-70" data-mp="2gmquhom81e6f" />

      {/* ── 04: PEOPLE WITH A BEAT ───────────────────────────── */}
      <section id="people" className="scroll-mt-20 rounded-t-[3rem] bg-white px-5 py-20 text-beat-black md:px-10 md:py-28" data-id="element-71" data-mp="3c3f7lhv585t">
        <div className="mx-auto max-w-[1200px]" data-id="element-72" data-mp="86ha7msm5d9y">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-73" data-mp="3qjf71ku3zpzw">
            <div data-id="element-74" data-mp="n2owcsnl0orv">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-75" data-mp="n25etd1ug2ed">
                People with a beat
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-76" data-mp="d2eir6xmxfc6">
                BEAT belongs to people with their own taste.
              </motion.h2>

              <motion.div variants={stagger} className="mt-10 grid gap-8 border-t border-black/10 pt-10" data-id="element-77" data-mp="2xtfac99rhj84">
                <PeopleItem title="Create" copy="Ideas that land. Nights that stay sharp all the way to the end." data-id="element-78" data-mp="32tt8mzlk9esy" />
                <PeopleItem title="Connect" copy="Conversations you actually remember. Presence you can feel." data-id="element-79" data-mp="2v7xvlhtabkqy" />
                <PeopleItem title="Move" copy="A body that shows up the next morning, ready to go again." data-id="element-80" data-mp="2q9waysg7nddd" />
              </motion.div>
            </div>

            <motion.div variants={rise} className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-81" data-mp="2zacd9yl7wegn">
              <div className="mt-12 md:mt-24" data-id="element-82" data-mp="2bl042ypw46ec">
                <img src={PEOPLE_IMAGE_1} alt="Candid shot of a woman drinking BEAT at a party" className="aspect-[3/4] w-full object-cover rounded-3xl" data-id="element-83" data-mp="2blt2ncep3ple" />
              </div>
              <div data-id="element-84" data-mp="2lbckceqo9deo">
                <img src={PEOPLE_IMAGE_2} alt="Candid shot of a man drinking BEAT with sunglasses" className="aspect-[3/4] w-full object-cover rounded-3xl" data-id="element-85" data-mp="2lbuorynhmxxo" />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── 05: THE WORLD IN MOTION ──────────────────────────── */}
      <Moment src={VIDEO_MOMENT} alt="Bartender grabbing a BEAT can from an ice bowl" label="Club · 23:45" isVideo data-id="element-86" data-mp="1ntmciuzkceuf" />

      {/* ── 06: THE STORY ────────────────────────────────────── */}
      <section id="story" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-87" data-mp="3sv6up38suejc">
        <div className="mx-auto max-w-[1200px]" data-id="element-88" data-mp="1jooiunmv4hu">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-89" data-mp="6hgpsfa642yp">
            <div data-id="element-90" data-mp="39y5ppif8wefe">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-91" data-mp="39xnixruyiht8">
                The Story
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-92" data-mp="3ezmmb1qp5eq6">
                São Paulo &rarr; Stockholm &rarr; BEAT.
              </motion.h2>
            </div>
            <div className="flex flex-col justify-center" data-id="element-93" data-mp="u9dtfj3grooq">
              <motion.p variants={rise} className="text-xl leading-relaxed text-white/70 md:text-2xl" data-id="element-94" data-mp="y71oqn92jjh5">
                Someone tasted something amazing. They couldn't stop thinking about it. They brought the idea home. They met the right people. BEAT happened.
              </motion.p>
              <motion.p variants={rise} className="mt-6 text-xl leading-relaxed text-white/70 md:text-2xl" data-id="element-95" data-mp="29xbp8qkd3j9e">
                The moment matters more than the beet.
              </motion.p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── 07: CLOSING ──────────────────────────────────────── */}
      <section className="relative overflow-hidden bg-beat-red px-5 py-24 md:px-10 md:py-32" data-id="element-96" data-mp="1uzrojvui0a91">
        <img src={CLOSING_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" data-id="element-97" data-mp="1qzr9qa3hlx1g" />
        <div className="absolute inset-0" style={{
        backgroundColor: '#C8102E',
        mixBlendMode: 'multiply',
        opacity: 0.55
      }} data-id="element-98" data-mp="1m2h8lx6qjwxs" />
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={stagger} className="relative z-10 mx-auto flex max-w-[1200px] flex-col items-center text-center" data-id="element-99" data-mp="3gfgx6ft3g1h7">
          <motion.h2 variants={rise} className="text-[13vw] font-medium leading-[1.05] tracking-tight sm:text-6xl md:text-7xl lg:text-[80px]" data-id="element-100" data-mp="2u6uysb1oylty">
            Don't waste
            <br data-id="element-101" data-mp="2khtj6lz266gi" />
            a heartbeat.
          </motion.h2>
        </motion.div>

        <div className="relative mx-auto mt-8 w-[68vw] max-w-[420px]" data-id="element-102" data-mp="26ilifon8yqa7">
          <div aria-hidden="true" className="absolute inset-[-12%] rounded-full" style={{
          background: 'radial-gradient(circle, rgba(255,255,255,0.42) 0%, rgba(255,255,255,0) 68%)'
        }} data-id="element-103" data-mp="26kohey6dntr2" />
          <img src={SILVER_HEART} alt="" aria-hidden="true" className="relative h-auto w-full" style={{
          mixBlendMode: 'multiply'
        }} data-id="element-104" data-mp="1wmii8obyh1pw" />
        </div>
      </section>

      {/* ── 08: JOIN ─────────────────────────────────────────── */}
      <section id="join" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-105" data-mp="3vxrz99snlsr8">
        <div className="mx-auto max-w-[1200px]" data-id="element-106" data-mp="1k9wsf88xc2j6">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-107" data-mp="1kaoik3jr5822">
            <div data-id="element-108" data-mp="1p99j642x1tr1">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-109" data-mp="1p8pwyb68gj77">
                Join
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-110" data-mp="232h97rbcmh6m">
                Join the BEAT.
              </motion.h2>
            </div>
            <motion.a variants={rise} href={`mailto:${CONTACT_EMAIL}`} className="text-2xl font-medium text-white underline decoration-beat-red decoration-2 underline-offset-8 transition-colors duration-150 hover:text-beat-red md:text-4xl" data-id="element-111" data-mp="2cyby346618hu">
              {CONTACT_EMAIL}
            </motion.a>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="grid gap-6 lg:grid-cols-3" data-id="element-112" data-mp="dnsz5wq8dbbr">
            <motion.a variants={rise} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="group flex flex-col justify-between rounded-3xl bg-white/5 p-8 transition-colors duration-150 hover:bg-beat-red" data-id="element-113" data-mp="21roughf5shrm">
              <Instagram size={26} className="mb-12 text-beat-red transition-colors duration-150 group-hover:text-white" data-id="element-114" data-mp="1ns7cakwdc2r8" />
              <div data-id="element-115" data-mp="1itmd8osurp4d">
                <h3 className="text-2xl font-medium" data-id="element-116" data-mp="1iue63rv2f8qy">
                  Follow
                </h3>
                <p className="mt-2 flex items-center gap-2 text-base text-white/60 transition-colors duration-150 group-hover:text-white/90" data-id="element-117" data-mp="1xr4wxcqobc4y">
                  @beatyourbest_
                  <ArrowUpRight size={18} data-id="element-118" data-mp="3950jv7ntkp6q" />
                </p>
              </div>
            </motion.a>

            <NotifyForm data-id="element-119" data-mp="3478i7lxdhopc" />
            <StockForm data-id="element-120" data-mp="345xfzqjksp0c" />
          </motion.div>
        </div>
      </section>

      {/* ── FOOTER ───────────────────────────────────────────── */}
      <footer className="px-5 py-12 md:px-10" data-id="element-121" data-mp="3gp1dxgodx17a">
        <div className="mx-auto flex max-w-[1200px] flex-col gap-8 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between" data-id="element-122" data-mp="3gpuiqc3s9gms">
          <BeatMark className="w-28" data-id="element-123" data-mp="36qvj1j0zwvbx" />
          <div className="flex flex-col gap-4 text-sm text-white/50 md:flex-row md:items-center md:gap-8" data-id="element-124" data-mp="36rwrrgujh5qh">
            <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-125" data-mp="3uhr29rrdyi7k">
              {CONTACT_EMAIL}
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 hover:text-white" data-id="element-126" data-mp="3loe2q6ytgici">
              Instagram
            </a>
            <p data-id="element-127" data-mp="3pnd4xjt5y109">© {new Date().getFullYear()} BEAT Soda</p>
          </div>
        </div>
      </footer>
    </div>;
}
function SiteHeader({
  onNavigate
}: {
  onNavigate: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  const go = (id: string) => {
    setOpen(false);
    window.setTimeout(() => onNavigate(id), 260);
  };
  return <>
      <header className={`fixed inset-x-0 top-0 z-40 transition-colors duration-200 ${scrolled && !open ? 'bg-beat-black/85 backdrop-blur' : 'bg-transparent'}`} style={{
      transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
    }} data-id="element-128" data-mp="45gobeqtb9f9">
        <div className="flex w-full items-center justify-between px-4 py-2 md:px-8 md:py-3" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        width: "1257px",
        height: "92px"
      }} data-id="element-129" data-mp="3qblzo0944xr5">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} aria-label="BEAT Soda — back to top" className="-ml-4 md:-ml-6" data-id="element-130" data-mp="3ba5eiy6lyhxa">
            <BeatMark className="w-36 md:w-48" data-id="element-131" data-mp="3gatbs1lfjuzy" />
          </button>

          <div className="flex items-center gap-3" data-id="element-132" data-mp="3l94m0dfn07ip">
            <button onClick={() => go('join')} className="hidden rounded-full bg-beat-red px-6 py-2.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black sm:inline-flex" data-id="element-133" data-mp="3q6mlzebofcek">
              Join the BEAT
            </button>
            <button onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-134" data-mp="2xiihgw4ud5dg">
              <Menu size={20} data-id="element-135" data-mp="29seaqfwcwpi8" />
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence data-id="element-136" data-mp="2eq6eq8aa022s">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} className="fixed inset-0 z-50 bg-beat-black" data-id="element-137" data-mp="kbis4q3fojt5">
            <div className="flex h-full w-full flex-col px-5 py-4 md:px-10 md:py-5" data-id="element-138" data-mp="u23zp3134yo7">
              <div className="flex items-center justify-between" data-id="element-139" data-mp="pac9itlucuyl">
                <BeatMark className="-ml-5 w-40 md:-ml-7 md:w-52" data-id="element-140" data-mp="1320gkih8gt8p" />
                <button onClick={() => setOpen(false)} aria-label="Close menu" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-141" data-mp="1307ap5eg2d1r">
                  <X size={20} data-id="element-142" data-mp="182erq9e4sjay" />
                </button>
              </div>

              <nav className="flex flex-1 flex-col justify-center" data-id="element-143" data-mp="3eqrp26k0zvfn">
                <motion.ul initial="hidden" animate="visible" variants={stagger} className="flex flex-col gap-2" data-id="element-144" data-mp="39sgf7vtqdkxf">
                  {NAV_LINKS.map(link => <motion.li key={link.id} variants={rise} data-id="element-145" data-mp="1pbgzu31ol2mu">
                      <button onClick={() => go(link.id)} className="text-4xl font-medium tracking-tight text-white/80 transition-colors duration-150 hover:text-beat-red md:text-6xl" data-id="element-146" data-mp="1u9it1gstmic1">
                        {link.label}
                      </button>
                    </motion.li>)}
                </motion.ul>
              </nav>

              <div className="flex flex-col gap-3 border-t border-white/10 py-6 text-base text-white/50 md:flex-row md:items-center md:justify-between" data-id="element-147" data-mp="16jogz1gbsxsu">
                <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-148" data-mp="1bgocwjjgok68">
                  {CONTACT_EMAIL}
                </a>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-149" data-mp="11lmr9xoea08e">
                  @beatyourbest_ <ArrowUpRight size={16} data-id="element-150" data-mp="2vxt8bd3yzb8m" />
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function BeatMark({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative flex items-center justify-center ${className}`} data-id="element-151" data-mp="2phb0yxukrffz">
      <img src={LOGO_URL} alt="BEAT Soda" className="h-auto w-full object-contain" data-id="element-152" data-mp="2kkauwmxq6cov" />
    </div>;
}
function Marquee() {
  const line = 'Good taste — Good people — Good times — ';
  return <div className="overflow-hidden bg-beat-red py-5" data-id="element-153" data-mp="3d7f3f1w1195e">
      <motion.div animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 22,
      ease: 'linear',
      repeat: Infinity
    }} className="flex w-max whitespace-nowrap" data-id="element-154" data-mp="388lr3csh7o6t">
        {[0, 1].map(group => <span key={group} className="text-lg font-medium uppercase tracking-widest text-white md:text-xl" data-id="element-155" data-mp="2zhlbubt50arz">
            {line.repeat(6)}
          </span>)}
      </motion.div>
    </div>;
}
function Moment({
  src,
  alt,
  label,
  isVideo = false
}: {
  src: string;
  alt: string;
  label: string;
  isVideo?: boolean;
}) {
  return <section className="relative h-[80vh] w-full overflow-hidden md:h-screen" data-id="element-156" data-mp="1dqwkabchwxnw">
      {isVideo ? <motion.video src={src} autoPlay loop muted playsInline initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-157" data-mp="1ip7wgsq9jk9a" /> : <motion.img src={src} alt={alt} initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-158" data-mp="1wm3evbsemo20" />}
      <p className="absolute bottom-6 left-5 text-sm font-medium tracking-widest text-white/80 uppercase md:left-10" data-id="element-159" data-mp="2ahfadledwijz">
        {label}
      </p>
    </section>;
}
function PeopleItem({
  title,
  copy
}: {
  title: string;
  copy: string;
}) {
  return <motion.div variants={rise} data-id="element-160" data-mp="1v9tp6ybymtbw">
      <h3 className="text-3xl font-medium md:text-4xl" data-id="element-161" data-mp="1v8s564cyuwi1">
        {title}
        <span className="text-beat-red" data-id="element-162" data-mp="1qagwvy2bku1x">.</span>
      </h3>
      <p className="mt-4 max-w-xs text-lg leading-relaxed text-black/60" data-id="element-163" data-mp="24bb2ya1waixf">
        {copy}
      </p>
    </motion.div>;
}
async function sendToBeat(payload: Record<string, string>) {
  const response = await fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      access_key: WEB3FORMS_KEY,
      from_name: 'BEAT Website',
      to: CONTACT_EMAIL,
      ...payload
    })
  });
  return response.ok;
}
function NotifyForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new launch signup',
      email,
      message: `New launch signup.\n\nEmail: ${email}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setEmail('');
  };
  return <motion.div variants={rise} className="flex flex-col justify-between rounded-3xl bg-white/5 p-8" data-id="element-164" data-mp="4tr8rf1clky7">
      <p className="mb-16 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-165" data-mp="9saxtob8ncus">
        Launch
      </p>
      <div data-id="element-166" data-mp="xhvh68bb0c4l">
        <h3 className="text-2xl font-medium" data-id="element-167" data-mp="xf0v6ccn6j92">
          Be first
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-base font-medium text-beat-red" data-id="element-168" data-mp="12e40lxwjarhk">
            <Check size={18} data-id="element-169" data-mp="nl0jtsqrohrw" /> You're on the list
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-4" data-id="element-170" data-mp="sh7rbpyta1by">
            <input type="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-171" data-mp="389etc1idmnrd" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-base font-medium text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-172" data-mp="2es9kqu5ls60s">
              {status === 'loading' ? 'Sending…' : 'Notify me →'}
            </button>
            {status === 'error' && <p className="text-sm text-white/50" data-id="element-173" data-mp="1r5b5fzt7z44g">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}
function StockForm() {
  const [form, setForm] = useState({
    company: '',
    email: '',
    notes: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!form.company || !form.email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new stockist enquiry',
      email: form.email,
      company: form.company,
      notes: form.notes || 'No notes',
      message: `New stockist enquiry.\n\nCompany: ${form.company}\nEmail: ${form.email}\nNotes: ${form.notes || 'No notes'}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setForm({
      company: '',
      email: '',
      notes: ''
    });
  };
  return <motion.div variants={rise} className="flex flex-col justify-between rounded-3xl bg-white/5 p-8" data-id="element-174" data-mp="muglb6c3iebu">
      <p className="mb-16 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-175" data-mp="i2gnbjfl5vhw">
        Trade
      </p>
      <div data-id="element-176" data-mp="d56s1n5impm5">
        <h3 className="text-2xl font-medium" data-id="element-177" data-mp="d4x19xcncefe">
          Stock BEAT
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-base font-medium text-beat-red" data-id="element-178" data-mp="87568ugpgc6z">
            <Check size={18} data-id="element-179" data-mp="35pnxa5wwjsa" /> We'll be in touch
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-4" data-id="element-180" data-mp="3v9i341hj9bye">
            <input type="text" required value={form.company} onChange={event => setForm({
          ...form,
          company: event.target.value
        })} placeholder="Venue or company" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-181" data-mp="3kowheuxfafgg" />
            <input type="email" required value={form.email} onChange={event => setForm({
          ...form,
          email: event.target.value
        })} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-182" data-mp="3gp5tr0370fg5" />
            <textarea rows={2} value={form.notes} onChange={event => setForm({
          ...form,
          notes: event.target.value
        })} placeholder="Volumes, timing, anything else" disabled={status === 'loading'} className="w-full resize-none border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-183" data-mp="3eon6hy7m1ie" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-base font-medium text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-184" data-mp="118hj8v5foqy0">
              {status === 'loading' ? 'Sending…' : 'Send enquiry →'}
            </button>
            {status === 'error' && <p className="text-sm text-white/50" data-id="element-185" data-mp="ibg4iim2vcgv">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}